import {CSSProperties, FC} from 'react';


export interface IIconBeltProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconBelt: FC<IIconBeltProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m18.417 2.25 3.333 3.333a.806.806 0 0 1 0 1.167l-1.932 1.932c.678.905.628 2.121-.151 2.901L18 13.25a.845.845 0 0 1-.398.227.817.817 0 0 1-.602-.06l-.917-.5c-.25-.167-.583-.084-.75.083l-1 1c-.583.583-1.5.583-2.083 0l-2.333-2.334a1.459 1.459 0 0 1 0-2.083l1.083-1c.166-.167.166-.5.083-.75l-.414-.759a.822.822 0 0 1-.155-.343c-.09-.36.086-.683.36-.856l1.543-1.542c.854-.777 2.071-.83 2.908-.158L17.25 2.25a.806.806 0 0 1 1.167 0ZM14.73 5.896l-.397-.396a.507.507 0 0 0-.666 0l-1 1.083c.333.333.75.583 1.25.833S15 8.083 15.5 8.583s.917 1.083 1.167 1.583.5.917.75 1.25l1.083-1.083a.507.507 0 0 0 0-.667l-.475-.475A1.722 1.722 0 0 1 18 9.167l-3.25-3.25a.9.9 0 0 1-.02-.02Zm1.853-.563 2.084 2.084L20 6.167 17.833 4l-1.25 1.333Zm-1.254 5.918-.005-.012a.382.382 0 0 1-.063-.125 7.061 7.061 0 0 1-.094-.197c-.167-.334-.5-.75-.917-1.167-.417-.417-.834-.75-1.167-.917a11.756 11.756 0 0 1-.157-.08l-.01-.003c-.062-.021-.125-.042-.166-.084a2.274 2.274 0 0 1-.584 1.084l-.916.916 2.083 2.084.917-.917c.332-.25.665-.498 1.08-.582Zm-2.83 4.915L7.834 11.5a.805.805 0 0 0-1.167 0L4.25 13.916a.806.806 0 0 0 0 1.167l.116.117-2.116 2.05a.806.806 0 0 0 0 1.167l3.333 3.333a.805.805 0 0 0 1.167 0l2.05-2.116.116.116a.806.806 0 0 0 1.167 0l2.417-2.417a.805.805 0 0 0 0-1.166ZM9.5 18 6 14.5l1.167-1.167 3.5 3.5L9.5 18Zm-3.332 2L4 17.833l1.5-1.416L7.583 18.5 6.167 20Z" clipRule="evenodd" />
        </svg>
    );
};
